import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty, last, startCase } from "lodash"

import { getParcelEventName } from "shared/utils"
import CONFIG from "core/config"

import Button from "shared/components/Button"
import CountryLabel from "shared/components/CountryLabel"

const DesktopItem = ({ parcel }, { t: translate }) => {
  const history = last(parcel.history)
  const parcelStatus = isEmpty(history) ? "Pending" : getParcelEventName(history.status)

  return (
    <tr key={parcel.tracking_number}>
      <td>
        <strong><Link to={`/parcel/${parcel.tracking_number}`}>{parcel.tracking_number}</Link></strong>
        <span className="fs-11 block">{parcel.provider_tracking_number}</span>
      </td>
      <td>
        <CountryLabel
          code={parcel.shipment.destination.country}
          label={<span>{parcel.shipment.destination.city}, {parcel.shipment.destination.country}</span>}
        />
      </td>
      <td>{parcelStatus}</td>
      <td className="textCapitalize">{startCase(parcel.shipment.service_code).toLowerCase()}</td>
      <td className="textRight">
        {parcel.glopal_tracking_available &&
        <Button
          color="primary"
          size="wide"
          href={`${CONFIG.glopalRedirectUrl}/parcel/${parcel.tracking_number}`}
          block
        >
          {translate("More details")}
        </Button>}
        {!parcel.glopal_tracking_available &&
        <Button
          color="primary"
          size="wide"
          to={`/parcel/${parcel.tracking_number}`}
          block
        >
          {translate("More details")}
        </Button>}
      </td>
    </tr>
  )
}

DesktopItem.propTypes = {
  parcel: PropTypes.object.isRequired,
}
DesktopItem.contextTypes = {
  t: PropTypes.func.isRequired,
}
export default DesktopItem



// WEBPACK FOOTER //
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableDesktop/components/Item/Item.js